module.exports = __webpack_public_path__ + "img/Frame_30.1e2cc50d.png";